import React, { PureComponent } from 'react';

export default class ElementLoader extends PureComponent {
  render(){
    if( !this.props.isLoading ){ return <div></div> }
    return <div className="el-dimmer">
      <div className="ui inverted text loader">{this.props.message || "Loading..."}</div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/element_loader.js